import { render, staticRenderFns } from "./ReportChallengeDataComponent.vue?vue&type=template&id=3815f1bf&"
import script from "./ReportChallengeDataComponent.vue?vue&type=script&lang=js&"
export * from "./ReportChallengeDataComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports